"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { PooRoutedPage } from './deskUi/PooRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function PooSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={PooRoutedPage} Loading={MsgDeskLoading} loadInitialSubsOnMsgRoute={false} />
}
